import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "icon-container" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "indicator" }, null, -1)
const _hoisted_5 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: _ctx.to,
    custom: "",
    replace: _ctx.replace
  }, {
    default: _withCtx(({ navigate, isActive, isExactActive }) => [
      _createElementVNode("div", {
        onClick: navigate,
        class: _normalizeClass(["navigation-bar-item", { active: isActive || isExactActive }])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.iconClass),
            textContent: _toDisplayString(_ctx.icon)
          }, null, 10, _hoisted_3),
          _hoisted_4
        ]),
        _createElementVNode("span", {
          class: "label-medium",
          textContent: _toDisplayString(_ctx.label)
        }, null, 8, _hoisted_5)
      ], 10, _hoisted_1)
    ]),
    _: 1
  }, 8, ["to", "replace"]))
}